class CommonAbstract {
  /**
   * @param editor 编辑器实例
   */
  constructor(editor) {
    this.editor = editor;
  }
  /**
   * 工具栏 JQ 对象
   */


  get $toolbar() {
    return this.editor.$toolbar;
  }
  /**
   * 内容区域 JQ 对象
   */


  get $container() {
    return this.editor.$container;
  }
  /**
   * 选区实例
   */


  get selection() {
    return this.editor.selection;
  }
  /**
   * 命令实例
   */


  get command() {
    return this.editor.command;
  }

}

export default CommonAbstract;